import { Check, Lock } from "lucide-react";

export const StepPill = ({ n, label, icon: Icon, state, onClick, testId }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={onClick}
    disabled={state === "locked"}
    className={`flex flex-1 items-center gap-2.5 rounded-xl border p-3 text-left transition-[background-color,border-color] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
      state === "active"
        ? "border-[hsl(174,38%,34%)] bg-[hsl(174,38%,96%)]"
        : state === "done"
        ? "border-[hsl(174,38%,70%)] bg-card hover:bg-muted"
        : state === "locked"
        ? "border-dashed bg-muted/50 text-muted-foreground"
        : "bg-card hover:bg-muted"
    }`}
  >
    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold ${
      state === "done"
        ? "bg-[hsl(174,38%,34%)] text-white"
        : state === "active"
        ? "bg-foreground text-background"
        : "bg-muted text-muted-foreground"
    }`}>
      {state === "done" ? <Check className="h-4 w-4" /> : state === "locked" ? <Lock className="h-3.5 w-3.5" /> : n}
    </span>
    <span className="min-w-0">
      <span className="flex items-center gap-1.5 text-sm font-semibold">
        <Icon className="h-3.5 w-3.5 shrink-0" /> <span className="truncate">{label}</span>
      </span>
      <span className="block text-[11px] text-muted-foreground">
        {state === "done" ? "Complete" : state === "active" ? "In progress" : state === "locked" ? "Locked" : "Not started"}
      </span>
    </span>
  </button>
);
